import React from "react";
import { useSelector, useDispatch } from "react-redux";
import InputField from "../input-field";
import { SET_TEMPLATE_GRID_LAYOUT_DATA } from "../../redux/constants/index";
import Select from "react-select";
import "../../css/theme.css";

function ReusableComponentSetting({
  componentForSetting,
  setComponentForSetting,
  setShowSetting,
  showSetting,
}) {
  const dispatch = useDispatch();
  const { componentGridLayoutData } = useSelector(
    (state) => state.bookingTemplate
  );

  // Function to get different icon
  const getIcon = (type) => {
    const iconMap = {
      text: "fas fa-text",
      dropdown: "fas fa-caret-square-down",
      toggle: "fas fa-toggle-on",
      "date/time": "far fa-calendar",
      "check box": "fas fa-check-square",
      link: "fas fa-link",
      "radio group": "fa-solid fa-circle-dot",
      paragraph: "fa-solid fa-p",
      number: "fa-solid fa-n",
    };
    const iconClass = iconMap[type];

    if (iconClass) {
      return <span className={`${iconClass} text-[--bg-color-500]`}></span>;
    } else {
      return null; // Return null or a default icon if needed for the default case
    }
  };

  const handleChange = (type, value) => {
    const arr = [...componentGridLayoutData];
    const newArr = arr.map((item) => {
      const componentObj = { ...item };
      if (
        componentObj.component.componentId ===
          componentForSetting.component.componentId &&
        type === "isMandatory"
      ) {
        componentObj.component.isMandatory = !componentObj.component.isMandatory;
        setComponentForSetting(componentObj);
      }
      return componentObj;
    });

    dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: newArr });
  };

  return (
    <div
      className="py-3 w-full h-screen relative space-y-3"
      style={{ maxHeight: "calc(100vh - 115px)" }}
    >
      <span
        className="fa-solid fa-xmark cursor-pointer absolute top-0 right-1 text-lg font-semibold"
        onClick={() => {
          setShowSetting(!showSetting);
          setComponentForSetting();
        }}
      />
      <h1
        className={`text-lg px-4 leading-3 tracking-tight font-bold text-[#535860] ${
          showSetting ? "block" : "hidden"
        }`}
      >
        Settings
      </h1>

      {componentForSetting && (
        <div className="rounded px-4 space-y-2 ">
          <div className="flex items-center justify-between">
            <h6 className={`text-sm font-medium tracking-tight leading-3`}>
              Is Mandatory
            </h6>
            <div className="form-switch">
              <input
                id="is_mandatory"
                type="checkbox"
                name="Advance Control Setting"
                checked={componentForSetting.component.isMandatory}
                className="sr-only"
                onChange={() => handleChange("isMandatory")}
                disabled={
                  componentForSetting.component.componentType === "link" ||
                  componentForSetting.component.componentType === "check box" ||
                  componentForSetting.component.componentType === "toggle"
                    ? true
                    : false
                }
              />
              <label htmlFor="is_mandatory" className="bg-slate-400">
                <span className="bg-white shadow-sm" aria-hidden="true"></span>
              </label>
            </div>
          </div>
        </div>
      )}

      <div
        className="h-full grid grid-rows-4 gap-4 w-full "
        style={{ maxHeight: "calc(100% - 70px)" }}
      >
        {componentForSetting && (
          <div className="rounded p-4 row-span-4 !w-full space-y-2 overflow-y-auto h-[95%]">
            <h4 className="text-sm font-bold leading-3 tracking-tight text-[#535860]">
              Component Configurations
            </h4>
            {componentForSetting.component.componentType !== "toggle" &&
            componentForSetting.component.componentType !== "check box" ? (
              <div className="grid grid-cols-1 gap-3">
                <div className="flex-1 space-y-1 w-full">
                  <label className={`block text-sm font-medium text-[#535860]`}>
                    Component Type
                  </label>
                  <div className="bg-white h-[38px] rounded flex items-center px-2 py-2 space-x-2 w-full border">
                    {getIcon(componentForSetting.component.componentType)}
                    <h6 className="text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500]">
                      {componentForSetting.component.componentType}
                    </h6>
                  </div>
                </div>

                <div>
                  <InputField
                    type="text"
                    label="Component ID"
                    labelClass="leading-3 tracking-tight"
                    value={componentForSetting.component.component_special_id}
                    readOnly
                    disabled
                  />
                </div>
                <div>
                  <InputField
                    type="text"
                    label="Component Name"
                    placeholder="Enter Component Name"
                    labelClass="leading-3 tracking-tight"
                    required
                    value={componentForSetting.component.componentName}
                    readOnly
                    disabled
                  />
                </div>
                {componentForSetting.component.componentType === "link" ? (
                  <div>
                    <InputField
                      type="text"
                      label="Link URL"
                      placeholder="Enter Component Placeholder"
                      labelClass="leading-3 tracking-tight"
                      required
                      value={componentForSetting.component.link_url}
                      readOnly
                      disabled
                    />
                  </div>
                ) : (
                  <div>
                    <InputField
                      type="text"
                      label="Component Placeholder"
                      placeholder="Enter Component Placeholder"
                      labelClass="leading-3 tracking-tight"
                      required
                      value={componentForSetting.component.componentPlaceholder}
                      readOnly
                      disabled
                    />
                  </div>
                )}

                <div className="flex-1 space-y-1">
                  <label className={`block text-sm font-medium text-[#535860]`}>
                    Tooltip
                  </label>
                  <textarea
                    rows="2"
                    className="w-full form-textarea resize-none bg-slate-100 text-slate-400"
                    placeholder="Enter Tooltip"
                    value={
                      componentForSetting.component.componentTooltip
                        ? componentForSetting.component.componentTooltip
                        : ""
                    }
                    readOnly
                    disabled
                  ></textarea>
                </div>

                {(componentForSetting.component.componentType === "text" ||
                  componentForSetting.component.componentType === "number") && (
                  <div>
                    <InputField
                      type="number"
                      label="Set Minimum Characters"
                      placeholder="Enter minimum value"
                      value={
                        componentForSetting.component.minimumValue
                          ? componentForSetting.component.minimumValue
                          : ""
                      }
                      required
                      readOnly
                      disabled
                    />
                  </div>
                )}

                {(componentForSetting.component.componentType === "text" ||
                  componentForSetting.component.componentType === "number") && (
                  <div>
                    <InputField
                      type="number"
                      label="Set Maximum Characters"
                      placeholder="Enter maximum value"
                      value={
                        componentForSetting.component.maximumValue
                          ? componentForSetting.component.maximumValue
                          : ""
                      }
                      required
                      readOnly
                      disabled
                    />
                  </div>
                )}

                {componentForSetting.component.componentType ===
                  "date/time" && (
                  <div className="space-y-4 w-full">
                    <div className="flex items-center justify-between">
                      <h6
                        className={`text-sm font-medium tracking-tight leading-3`}
                      >
                        Allow Prior Date
                      </h6>
                      <div className="form-switch">
                        <input
                          id="past_date"
                          type="checkbox"
                          name="Advance Control Setting"
                          checked={componentForSetting.component.priorDate}
                          className="sr-only"
                          readOnly
                          disabled
                        />
                        <label htmlFor="past_date" className="bg-slate-400">
                          <span
                            className="bg-white shadow-sm"
                            aria-hidden="true"
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <h6
                        className={`text-sm font-medium tracking-tight leading-3`}
                      >
                        Allow Future Date
                      </h6>
                      <div className="form-switch">
                        <input
                          id="future_date"
                          type="checkbox"
                          name="Advance Control Setting"
                          checked={componentForSetting.component.futureDate}
                          className="sr-only"
                          disabled
                        />
                        <label htmlFor="future_date" className="bg-slate-400">
                          <span
                            className="bg-white shadow-sm"
                            aria-hidden="true"
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {(componentForSetting.component.componentType === "dropdown" ||
                  componentForSetting.component.componentType ===
                    "radio group") && (
                  <div className="space-y-2 w-full">
                    <h6 className="text-[13px] font-medium leading-3 tracking-tight text-[#535860]">
                      {componentForSetting.component.componentType ===
                      "dropdown"
                        ? "Dropbox Items"
                        : "Radio Items"}
                    </h6>
                    <div className="space-y-1">
                      {componentForSetting.component.dropDownOption?.map(
                        (item, index) => (
                          <InputField
                            key={index}
                            type="text"
                            value={item}
                            labelClass="hidden"
                            readOnly
                            disabled
                          />
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-3">
                <div className="flex-1 space-y-1">
                  <label className={`block text-sm font-medium text-[#535860]`}>
                    Component Type
                  </label>
                  <div className="bg-white h-[38px] rounded flex items-center px-2 py-2 space-x-2 border">
                    {getIcon(componentForSetting.component.componentType)}
                    <h6 className="text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500]">
                      {componentForSetting.component.componentType}
                    </h6>
                  </div>
                </div>

                <div>
                  <InputField
                    type="text"
                    label="Component ID"
                    labelClass="leading-3 tracking-tight"
                    disabled
                    value={componentForSetting.component.component_special_id}
                    readOnly
                  />
                </div>
                <div>
                  <InputField
                    type="text"
                    label="Label"
                    placeholder="Enter Label Name"
                    labelClass="leading-3 tracking-tight"
                    required
                    value={componentForSetting.component.componentName}
                    readOnly
                    disabled
                  />
                </div>

                <div className="flex justify-start items-center">
                  <div className="flex items-center space-x-3">
                    <input
                      id="controlSetting"
                      type="checkbox"
                      name="Advance Control Setting"
                      className="form-checkbox !bg-slate-100 checked:!bg-slate-500"
                      checked={componentForSetting.component.isCheckedByDefault}
                      readOnly
                      disabled
                    />
                    <label
                      htmlFor="controlSetting"
                      className="text-sm font-medium cursor-pointer"
                    >
                      is checked by default
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ReusableComponentSetting;
